<script>

    import { userStore } from '../stores'
    import { toast } from 'bulma-toast'

    import ShipmentsService from '../$services/shipments.service'
    import DateMethod from '../$methods/date.method'

    import DetailsCard from '../$components/details.card.svelte'
    import Button from '../$components/button.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Date from '../$components/date.svelte'
    import Switch from '../$components/switch.svelte'

    import SelectUsers from '../$components/select.users.svelte'
    import SelectProviders from '../$components/select.providers.svelte'

    export let all = false

    let data = {}
    let loading = false
    let element

    async function getShipmentsReport() {

        if(all === false)
            data.userId = $userStore._id
        else
            data.all = true

        loading = true
        const blob = await ShipmentsService.getShipmentsReport(data)
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = !all? `${ $userStore.email }_` : 'envios_'
            fileName += `${ DateMethod.dateShort(data.dateStart) }_${ DateMethod.dateShort(data.dateEnd) }`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title="Reporte de envíos"
        meta="Filtros opcionales y rango de fechas. El archivo se descarga en formato XLSX."
    >
        <form id="shipments-report-form" on:submit|preventDefault={getShipmentsReport}>
            <div class="columns is-multiline is-variable is-4">
                <div class="column is-half-tablet">
                    <SelectUsers bind:userId={data.driverId} role="driver" label="Conductor" required={false} />
                </div>
                <div class="column is-half-tablet">
                    <SelectProviders bind:provider={data.provider} />
                </div>
                <div class="column is-half-tablet">
                    <Date label="Fecha de inicio" bind:value={data.dateStart} />
                </div>
                <div class="column is-half-tablet">
                    <Date label="Fecha final" bind:value={data.dateEnd} />
                </div>
                <div class="column is-full">
                    <Switch label="Envíos con reembolso" bind:checked={data.refund} />
                </div>
            </div>
            <hr class="my-4" />
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <Button type="submit" form="shipments-report-form" text="Descargar" icon="download" { loading } />
            </div>
        </form>
    </DetailsCard>
{/if}
